const componentList = [];
const interactions = new Map();


/**
 * Adds a component to the framework.
 * @param {*} component The Vue component to add.
 * @returns {void}
 */
export const useComponent = function(component) {
    componentList.push(component);
};

/**
 * Adds an array of components to the application.
 * @param {Array} components an array of Vue components to add.
 * @returns {void}
 */
export const useComponents = function(components) {
    components.forEach((component) => useComponent(component));
};

export const getComponents = function() {
    return componentList;
};


/**
 * Adds a custom interaction function to the framework.
 * @param {string} name The name of the interaction function to add.
 * @param {function} interaction The interaction function to add.
 * @returns {void}
 */
export const useInteraction = function(name, interaction) {
    interactions.set(name, interaction);
};

/**
 * Adds an object container custom functions to the application.
 * @param {*} interactions The object containing functions to add.
 * @returns {void}
 */
export const useInteractions = function(interactions) {
    Object.keys(interactions).forEach((name) => useInteraction(name, interactions[name]));
};


export const getInteractions = function() {
    return interactions;
};


// WEBPACK FOOTER //
// ./source/framework/instance/features.js